
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-100 sticky top-0 z-50">
      <nav className="px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center ml-8">
            <img 
              src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/b32d519b06086cbdd09de78a334ea038.png" 
              alt="Dr. Remess Urología - Laparoscopía, Robótica, Láser" 
              className="h-20 w-20 object-contain"
            />
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="#inicio" className="text-gray-700 px-3 py-2 text-sm font-medium transition-colors cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Inicio
              </a>
              <a href="#tratamientos" className="text-gray-700 px-3 py-2 text-sm font-medium transition-colors cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Tratamientos
              </a>
              <a href="#papiloma-center" className="text-gray-700 px-3 py-2 text-sm font-medium transition-colors cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Papiloma Center
              </a>
              <a href="#galeria" className="text-gray-700 px-3 py-2 text-sm font-medium transition-colors cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Galería
              </a>
              <a href="#contacto" className="text-gray-700 px-3 py-2 text-sm font-medium transition-colors cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Contacto
              </a>
              <a 
                href="https://wa.me/523333958988?text=Hola%20Doctor,%20me%20gustaría%20agendar%20una%20consulta"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white px-4 py-2 rounded-lg text-sm font-medium hover:opacity-90 transition-colors whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#20C6B2' }}
              >
                Agenda Consulta
              </a>
            </div>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="cursor-pointer hover:opacity-80"
              style={{ color: '#1A1A1A' }}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100">
              <a href="#inicio" className="block px-3 py-2 text-base font-medium cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Inicio
              </a>
              <a href="#tratamientos" className="block px-3 py-2 text-base font-medium cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Tratamientos
              </a>
              <a href="#papiloma-center" className="block px-3 py-2 text-base font-medium cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Papiloma Center
              </a>
              <a href="#galeria" className="block px-3 py-2 text-base font-medium cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Galería
              </a>
              <a href="#contacto" className="block px-3 py-2 text-base font-medium cursor-pointer hover:opacity-80" style={{ color: '#1A1A1A' }}>
                Contacto
              </a>
              <a 
                href="https://wa.me/523333958988?text=Hola%20Doctor,%20me%20gustaría%20agendar%20una%20consulta"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-left text-white px-3 py-2 rounded-lg text-base font-medium hover:opacity-90 transition-colors whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#20C6B2' }}
              >
                Agenda Consulta
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
